module.exports = new __parcel__URL__("cornershop-shopper-android.23a1bcf5.png").toString();